module.exports = __webpack_public_path__ + "img/inter21.b520e9df.jpg";